import React, { Suspense, useState, useEffect, useCallback } from 'react'

import { AreasSelector, ActiveFilterViewer, Filters } from '@rankmi/rankmi-table'
import './FilterOptions.scss'

import { Button, Col, Dropdown, Menu, Row, Typography, Input } from 'antd'
import { DownOutlined, UnorderedListOutlined } from '@ant-design/icons'
import { activeFiltersViewLocale, areaslocale, columnsFilter, filtersLocale } from '../../../src/utilities/filter_config';
import { initalStateFilters, haveApplicants } from '../settings/initialStates'
import TagButton from '../TagButton/TagButton'
import { AddProcessModalComponent } from '@rankmi/ats-app'
import { SelectionProcessesService } from '../../../src/core/services/selection_processes_service'

const { Title, Text} = Typography;
const { SubMenu } = Menu;
const { Search } = Input;
const SELECTION_PROCCESS_FILTERS = 'SELECTION_PROCCESS_FILTERS'
const initialFilter = {
  data: [],
  groupedData: [],
  generalCondition: 'and',
  filterType: 'simple',
};


const FilterOptions = (
  {
    areas,
    selectionProcessesSize,
    handleSort, onChangeFilters,
    handleImport,
    handleDownload,
    onChangeArea,
    authors,
    onSearch,
    statuses = [],
    isBasicWithUserColumns,
    isAdmin,
    userRole,
    pendingProcesses = 0,
    closingReasons = [],
    activeItem,
    setActiveItem,
    canCreate,
    titleAllProcess,
    openFilter,
    setOpenFilters,
    workflowConfigurations = [],
    onTransactionalMovementsReportVisible,
    transactionalMovementsReportDisabled = false,
  }
) => {

  const [selectedArea, setSelectedArea] = useState(undefined);
  const storageFilters =
    JSON.parse(localStorage.getItem(SELECTION_PROCCESS_FILTERS)) ||
    initialFilter;
  const defaultData = hasPermissions() ? [haveApplicants] : [];
  const defaultGroupedData = hasPermissions()
    ? [{ data: [haveApplicants], group: 0, groupCondition: 'and' }]
    : [];

  const [filtersSelected, setFiltersSelected] = useState({
    ...storageFilters,
    data: storageFilters.data.length ? storageFilters.data : defaultData,
    groupedData: storageFilters.groupedData.length
      ? storageFilters.groupedData
      : defaultGroupedData,
  });
  const [showModalCopyProcess, setShowModalCopyProcess] = useState(false)
  const [requestOwners, setRequestOwners] = useState([])

  function hasPermissions() {
    return isBasicWithUserColumns && ["employee", "user"].includes(userRole)
  }

  const fetchRequestOwners = useCallback(async (page = 1, term = "") => {
    try {
      const { data } = await new SelectionProcessesService().listUsers(
        [],
        page,
        100,
        term,
        "all_users"
      );
      const mapped = data.map((u) => ({
        label: `${u.full_name}`,
        value: u.token,
      }));
      setRequestOwners(mapped);
      return mapped;
    } catch (e) {
      // ignore
      return [];
    }
  }, []);

  useEffect(() => {
    if (openFilter && requestOwners.length === 0) {
      fetchRequestOwners(1, "");
    }
  }, [openFilter, requestOwners]);

  const handleOnChangeFilters = (currentFilters, statusId = activeItem) => {
    const { groupedData = [] } = currentFilters;
    const statusFilterArray = statusId > 0 ? initalStateFilters({ id: statusId }).data : []
    const newGroupedDataArray = groupedData.length > 0
      ? [{
        ...groupedData[0],
        data: groupedData[0].data.concat(statusFilterArray),
      }]
      : initalStateFilters({ id: statusId }).groupedData
    const updatedFilters = {
      ...currentFilters,
      data: currentFilters.data.concat(statusFilterArray),
      groupedData: newGroupedDataArray
    }

    setActiveItem(statusId)

    const activeItemFilters = {
      ...currentFilters,
      activeItem: statusId
    }

    localStorage.setItem(SELECTION_PROCCESS_FILTERS, JSON.stringify(activeItemFilters))
    setFiltersSelected(activeItemFilters)
    onChangeFilters({...updatedFilters, activeItem: statusId})
  }

  const handlePendingNotification = (status) => {
    return (status.value === 8) ? pendingProcesses : 0
  }

  const menu = (
    <Menu>
      <SubMenu title="Ordenar por">
        <Menu.Item key="newest" onClick={(value) => handleSort(value)}>
          Agregados recientes
        </Menu.Item>
        <Menu.Item key="oldest" onClick={(value) => handleSort(value)}>
          {'Anteriores -> Nuevos'}
        </Menu.Item>
        <Menu.Item key="modified" onClick={(value) => handleSort(value)}>
          Actualizados recientes
        </Menu.Item>
      </SubMenu>
      { !hasPermissions() && (
          <Menu.Item key="import" onClick={() => handleImport()}>
            Carga de procesos
          </Menu.Item>
      )}
      { !hasPermissions() && (
          <Menu.Item key="download" onClick={() => handleDownload()}>
            Descargar de procesos
          </Menu.Item>
      )}
      {isAdmin && !hasPermissions() && (
        <Menu.Item
          key="transactional-temporalidad"
          disabled={transactionalMovementsReportDisabled}
          onClick={() => onTransactionalMovementsReportVisible?.()}
        >
          Reporte de Temporalidad
        </Menu.Item>
      )}
    </Menu>
  );

  return (
    <div className="filter-options">
      <Row>
        <Col xs={24} sm={24}>
          <Title level={3} className='title-purple' style={{ fontWeight: 'normal' }}>Procesos de selección</Title>
        </Col>
      </Row>
      <Row>
        <Col xs={24} sm={24} style={{ display: 'flex' }}>
          <div className="filter-area" style={{ display: 'flex', width: '50%' }}>
            <div style={{ width: '26%', marginRight: '5px'}}>
              <AreasSelector
                areas={areas}
                selectedArea={selectedArea}
                loading={false}
                onAreaSelected={(area) => {
                  setSelectedArea(area)
                  onChangeArea(area)
                }}
                mandatoryArea={false}
                locale={areaslocale}
                style={{ width: '26%' }}
              />
            </div>
            <Filters
              open={openFilter}
              onVisibilityChange={(state) => setOpenFilters(state)}
              columns={columnsFilter({
                authors: authors,
                workflowConfigurations: workflowConfigurations,
                closingReasons: closingReasons,
                requestOwners: requestOwners,
                searchFunctions: { fetchRequestOwners: fetchRequestOwners }
              })}
              selectedFilters={filtersSelected}
              onChange={(activeFilters) => handleOnChangeFilters(activeFilters)}
              locale={filtersLocale}
              loading={false}
              onlySimpleFilters
            />
          </div>
          <div className="action-buttons" style={{ width: '50%' }}>
            <div style={{ width: '100%' }}>
              <Dropdown overlay={menu} trigger={['click']}>
                <Button size='large' style={{ float: 'right' }}>
                  Acciones <DownOutlined />
                </Button>
              </Dropdown>
              {canCreate && (
                <Button type='primary' onClick={() => setShowModalCopyProcess(true)} size='large' className="action-buttons-add" style={{ float: 'right' }}>
                  Agregar nuevo proceso
                </Button>
              )}
              {showModalCopyProcess && (
                <Suspense fallback="">
                  <AddProcessModalComponent
                    visible={showModalCopyProcess}
                    onCancel={() => setShowModalCopyProcess(false)}
                  />
                </Suspense>
              )}
            </div>
          </div>
        </Col>
      </Row>
      {filtersSelected !== undefined &&
        <Row>
          <Col xs={24} sm={24}>
            <ActiveFilterViewer
              columns={columnsFilter({
                authors: authors,
                closingReasons: closingReasons,
                workflowConfigurations: workflowConfigurations,
                requestOwners: requestOwners,
                searchFunctions: { fetchRequestOwners: fetchRequestOwners }
              })}
              activeFilters={filtersSelected}
              onChange={(activeFilters) => handleOnChangeFilters(activeFilters)}
              openFilters={() => setOpenFilters(true)}
              locale={activeFiltersViewLocale}
            />
          </Col>
        </Row>
      }
      <Row style={{ marginTop: '10px' }}>
        <Col span={3}>
          <div className="tag-process">
            <div className="tag-process-icon">
              <UnorderedListOutlined />
            </div>
            <div className="tag-process-text">
              <Text>{selectionProcessesSize} proceso(s)</Text>
            </div>
          </div>
        </Col>
        <Col span={7} offset={14}>
          <Search placeholder="Buscar" onSearch={onSearch} enterButton size="large" />
        </Col>
      </Row>
      <Row style={{ marginTop: '10px' }}>
        {statuses.map(status => (
          <TagButton
            key={status.value}
            onClick={() => handleOnChangeFilters(filtersSelected, status.value)}
            title={`${status.label}`}
            active={activeItem === status.value}
            amount={handlePendingNotification(status)}
          />
        ))}
        <TagButton
          onClick={() => handleOnChangeFilters(filtersSelected, 0)}
          title={titleAllProcess}
          active={activeItem === 0}
        />
      </Row>
    </div>
  )
}

export default FilterOptions
